const FEATURE_FLAGS = {
  ARCGIS_BASEMAPS: 'arcgis_basemaps',
  NEW_INSPECTION_SUBMISSION: 'leadcast_new_inspection_submission',
  NEW_SAMPLING_TABLES: 'leadcast_new_sampling_tables',
  ASYNC_INVENTORY_EXPORT: 'leadcast_async_inventory_export',
  CUSTOMER_CONTACT: 'leadcast_customer_contact',
  LEADCAST_GEOCODING: 'leadcast_geocoding',
  LEADCAST_TOUCHPOINT_TRACKING: 'leadcast_touchpoint_tracking',
  LEADCAST_PREDICT_DASHBOARD: 'leadcast_predict_dashboard',
  SAMPLING_DASH_AND_MAP: 'leadcast_sampling_dashboard',
  INV_MAP_VERIFICATIONS_LAYER_ENABLED: 'leadcast_inventory_map_show_verifications_layer',
  LEADCAST_REPLACEMENTS_DASHBOARD: 'leadcast_replacements_dashboard',
  SCHOOL_AND_DAYCARE: 'leadcast_school_and_daycare',
  ROE_MANAGER_APPROVAL: 'leadcast_roe_manager_approval',
} as const;

export type FeatureFlagOptions = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export default FEATURE_FLAGS;
